import moment from "moment";
import { useStyles } from "./RCALibraryDueDateCell.styles";
import { useMemo } from "react";
import MainTag from "components/MainTag";
import { MainTagTypeEnum } from "components/MainTag/MainTagInterfaces";
import { useTranslation } from "react-i18next";
import { RCA_STATUSES } from "constants/constants";
import { isLate } from "utilities/utilities";
import { IRCALibraryDueDateCell } from "./RCALibraryDueDateCellInterfaces";
import useDateFormat from "hooks/useDateFormat";

const RCALibraryDueDateCell = ({ rca }: IRCALibraryDueDateCell) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { formatDate } = useDateFormat();

    const showLateTag = useMemo(() => {
        return isLate(new Date(rca.due_date).toISOString()) && rca.status?.status_id !== RCA_STATUSES.COMPLETED;
    }, [rca.due_date, rca.status?.status_id]);

    const showDueTodayTag = useMemo(() => {
        return (
            moment(new Date(rca.due_date).toISOString()).isSame(moment(), "day") &&
            rca.status?.status_id !== RCA_STATUSES.COMPLETED
        );
    }, [rca.due_date, rca.status?.status_id]);

    return (
        <div className={`${classes.descriptionWrapper} ${showLateTag ? classes.textRed : ""}`}>
            <span>{formatDate(rca.due_date)}</span>
            {showLateTag && <MainTag type={MainTagTypeEnum.ERROR}>{t("rca.rca_library.late")}</MainTag>}
            {showDueTodayTag && <MainTag type={MainTagTypeEnum.WARNING}>{t("rca.rca_library.due_today")}</MainTag>}
        </div>
    );
};

export default RCALibraryDueDateCell;
